import { FaTelegram } from "react-icons/fa";
import { FaFacebook, FaLinkedin } from "react-icons/fa6";

const ContactIon = () => {
  const links = [
    {
      id: 1,
      icon: <FaLinkedin size={20} />,
      text: "LinkedIn",
      href: "https://linkedin.com/company/ethio-cert",
      bgColor: "bg-[#063b46]",
    },
    {
      id: 2,
      icon: <FaFacebook size={20} />,
      text: "Facebook",
      href: "https://facebook.com/ethiocert",
      bgColor: "bg-blue-600",
    },
    {
      id: 3,
      icon: <FaTelegram size={20} />,
      text: "Telegram",
      href: "https://t.me/Ethio_Cert_933",
      bgColor: "bg-blue-400",
    },
  
  ];

  return (
    <div className="hidden xl:flex flex-col top-[15%] right-0 fixed z-50 ">
      <ul>
        {links.map(({ id, icon, text, href, bgColor, download }) => (
          <li
            key={id}
            className={`${bgColor} flex justify-start items-center w-auto h-[40px] px-3 hover:ml-[-60px] group duration-200 relative`}
          >
            <a
              href={href}
              className="flex justify-between items-center w-full text-white"
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              <div className="flex items-center  w-full">
                {icon}
                <span className="absolute left-8 hidden group-hover:block whitespace-nowrap">
                  {text}
                </span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ContactIon;
